<script>
  import { onMount, onDestroy } from 'svelte';
  export let headerImage;
  export let alt;
  export let title;
  export let text;
  export let hashID;

  import CircleIMG from './circleIMG.svelte';
  import Button from './whiteButton.svelte';

  let diameter = '250px'; // Default value

  // Function to update diameter based on window width
  function updateDiameter() {
    diameter = window.innerWidth < 768 ? '125px' : '250px';
    console.log(`Diameter updated to: ${diameter}`); // Debugging line
  }

  let windowWidth;

  // Function to update window width
  function updateWidth() {
    windowWidth = window.innerWidth;
  }

  onMount(() => {
    // Update width on mount
    updateWidth();
    // Add event listener for window resize
    window.addEventListener('resize', updateWidth);

    // Initialize diameter
    updateDiameter();
    // Listen for resize to adjust diameter
    window.addEventListener('resize', updateDiameter);

    // Cleanup function
    return () => {
      window.removeEventListener('resize', updateWidth);
      window.removeEventListener('resize', updateDiameter);
    };
  });
</script>


<div class="card">
  <CircleIMG
    src={headerImage}
    diameter={diameter}
    alt={alt}
  />
  {#if windowWidth < 768}
    <br>
  {:else}
    <br><br>
  {/if}
  <h1>{@html title}</h1>
  {#if windowWidth < 768}
    <br>
  {:else}
    <br><br>
  {/if}
  <p>{@html text}</p>
  <div class="button-container">
    <Button
      link="./about?section={hashID}"
      text="READ MORE"
    />
  </div>
</div>

<style>
  .card {
    position: relative;
    color: #fff;
    padding: 1rem;
    border-radius: 1rem;
    text-align: center;
    width: 360px;
    height: 650px;
    background-color: #f7931e;
  }
  h1 {
    font-family: 'Oswald', sans-serif;
  }
  .card > * {
    display: inline-block;
    vertical-align: middle;
  }
  .button-container {
    position: absolute;
    bottom: 1rem;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
  }

  /* Responsive adjustments for screens 768px or smaller */
  @media (max-width: 768px) {
    .card {
      padding: 0.25rem;
      width: 180px; /* Half of 360px */
      height: 325px; /* Half of 650px */
      background-color: #f7931e;
    }
    h1, p {
      font-size: 0.5em; /* Adjust font size to be smaller */
    }
    .button-container {
    position: absolute;
    bottom: 0.25rem;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
  }
  }
</style>
